import WordSeparator from './Root.vue';
import WordGroupsPage from './views/WordGroupsPage.vue';

export default {
  path: 'separador/palavras-grupos',
  name: 'admin-word-groups',
  component: WordSeparator,
  redirect: '/novo',
  children: [
    {
      path: 'novo',
      name: 'admin-word-groups-new',
      component: WordGroupsPage,
    },
  ],
};
